/**
 * Created by Carsten Bühler
 * User: CBuehler on 08.12.2015
 * Copyright: xdot GmbH 2015
 */

import { Client } from 'external/lwr-client';
import { ApiUtil, FormDataUtil } from 'plugin/liferay-widgets-react-web';

const journalEntryService = (m, o) => Client.invoke('/journal.journalentry/' + m, o);
const journalEntryServiceWithContext = (m, o, c) => Client.invokeWithContext('/journal.journalentry/' + m, o, c);

let api = {

    addEntry({ groupId, className, classPK, type, attachments, message }){

        const data = {
            groupId, type, attachments, message: JSON.stringify(message)
        };
        if (className) {
            data.className = className;
        }
        if (classPK) {
            data.classPK = classPK;
        }
        const formData = FormDataUtil.toFormData(data);
        let d2 = {};
        for (var pair of formData.entries()) {
            d2[pair[0]] = pair[1];
        }
        console.log('Entry data', data, d2);
        return journalEntryService('add-journal-entry.1', formData);
    },

    search(query){
        return journalEntryServiceWithContext('search.3', {
            start: query.start,
            end: query.end
        }, {
            categoryKeys: query.categoryKeys.toString(),
            startDate: query.startDate && query.startDate.getTime(),
            endDate: query.endDate && query.endDate.getTime()
        });
    }
};

ApiUtil.namedApi('JournalWebApi', api);

export default api;



// WEBPACK FOOTER //
// ./js/webapi/JournalWebApi.js